import { Component, OnInit, OnDestroy, HostListener, AfterViewInit } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import 'hammerjs';
import * as $ from 'jquery';
import * as slick from 'ngx-slick';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss'],
})

export class BrandsComponent implements OnInit, OnDestroy, AfterViewInit {

  private fragment: string;

  imageUrls = [
    {
        url: './assets/images/carousel-image.jpg',
        caption: '<p>"Trusted and reputable company.  I did research on the best price for the quality ' +
        'I was receiving of fish oil supplements, and this beat out 200 other products.  ' +
        'Very happy with this brand."</p>' + '<br><h3>ANDREW</h3>'
    },
    {
        url: './assets/images/carousel-image.jpg',
        caption: '<p>"Have ordered 6 times and it' + "'" + 's the best I' + "'" + 've found... ' +
        'I am a huge Dr Tobias fan and take several of his supplements."</p>' + '<br><h3>AMAZON CUSTOMER</h3>'
    },
    {
        url: './assets/images/carousel-image.jpg',
        caption: '<p>"Seem to have more energy and have definitely noticed a difference in digestive health."</p>' + '<br><h3>DEBRA</h3>'
    },
  ];

  constructor(public angulartics2: Angulartics2,
              private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'page-view-brands'
      });
      console.log(this.angulartics2);
    }
  }

  ngAfterViewInit(): void {
    try {
      if (this.fragment === 'title') {
        $('html,body').scrollTop();
      } else {
        $('html, body').animate({scrollTop: $('#' + this.fragment).offset().top - 70}, {duration: 'medium'});
      }
    } catch (e) {
      // console.log(e);
    }
    if (window.innerWidth >= 1195) {
      $('#about-link').addClass('grey-text');
      $('#brands-link').addClass('grey-text');
      $('#team-link').addClass('grey-text');
      $('#investors-link').addClass('grey-text');
      $('#contact-link').addClass('grey-text');
    }
    $('.prev').css('display', 'none');
  }

  ngOnDestroy() {

  }

  gotoTeam() {
    $('html, body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '235px'});
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.add('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
  }

  externalLink() {
    window.open('https://www.amazon.com/stores/Dr-Tobias/node/8971601011', '_blank');
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'tobias-external-link'
      });
      console.log(this.angulartics2);
    }
  }

  amazonLink() {
    window.open('https://www.amazon.com/stores/Dr-Tobias/node/8971601011', '_blank');
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'tobias-external-link'
      });
      console.log(this.angulartics2);
    }
  }

}
